
import DashboardBox from "./components/dashboardBox";
import { FaUserCircle, FaTrophy, FaChartLine, FaBoxOpen } from "react-icons/fa";
import { IoMdCart } from "react-icons/io";
import { MdShoppingBag, MdTrendingUp, MdTrendingDown } from "react-icons/md";
import { GiStarsStack } from "react-icons/gi";
import SearchBox from "../../components/SearchBox";
import MenuItem from "@mui/material/MenuItem";
import { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { FaPencilAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { MyContext } from "../../App";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import Rating from "@mui/material/Rating";
import { deleteData, fetchDataFromApi } from "../../utils/api";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  AreaChart,
  Area,
  RadialBarChart,
  RadialBar,
  LabelList
} from "recharts";

import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Alert,
  Avatar,
  Chip,
  LinearProgress,
  Divider,
  IconButton
} from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";






export const options = {
  backgroundColor: "transparent",
  chartArea: { width: "100%", height: "100%" },
};

const columns = [
  { id: "product", label: "PRODUCT", minWidth: 150 },
  { id: "category", label: "CATEGORY", minWidth: 100 },
  {
    id: "subcategory",
    label: "SUB CATEGORY",
    minWidth: 150,
  },
  {
    id: "brand",
    label: "BRAND",
    minWidth: 130,
  },
  {
    id: "price",
    label: "PRICE",
    minWidth: 100,
  },
  {
    id: "rating",
    label: "RATING",
    minWidth: 80,
  },
  {
    id: "action",
    label: "ACTION",
    minWidth: 120,
  },
];

// Enhanced Power BI inspired color schemes
const powerBIColors = {
  primary: ['#0078d4', '#00bcf2', '#8764b8', '#00cc6a', '#ffb900', '#ff8c00', '#e81123', '#005a9e'],
  secondary: ['#106ebe', '#40e0d0', '#9a4993', '#00a86b', '#ffa500', '#ff4500', '#b22222', '#003d5c'],
  success: ['#00cc6a', '#32cd32', '#228b22', '#006400'],
  warning: ['#ffb900', '#ffa500', '#ff8c00', '#ff6347'],
  error: ['#e81123', '#dc143c', '#b22222', '#8b0000'],
  info: ['#0078d4', '#1e90ff', '#4169e1', '#0000cd'],
  gradient: {
    blue: ['#0078d4', '#106ebe', '#005a9e', '#004578', '#003d5c'],
    green: ['#00cc6a', '#00a86b', '#008b5b', '#006d48', '#005035'],
    orange: ['#ffb900', '#ffa500', '#ff8c00', '#ff6347', '#ff4500'],
    purple: ['#8764b8', '#9a4993', '#663399', '#4b0082', '#301934']
  }
};

// Enhanced status color mapping
const getStatusColor = (status) => {
  const statusColors = {
    'pending': '#ffb900',
    'confirmed': '#0078d4',
    'processing': '#8764b8',
    'shipped': '#00bcf2',
    'delivered': '#00cc6a',
    'cancelled': '#e81123'
  };
  return statusColors[status?.toLowerCase()] || '#6c757d';
};

const Dashboard = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showBy, setshowBy] = useState(10);
  const [showBysetCatBy, setCatBy] = useState("");
  const [productList, setProductList] = useState([]);
  const [categoryVal, setcategoryVal] = useState("all");

  const [totalUsers, setTotalUsers] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalProductsReviews, setTotalProductsReviews] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [perPage, setPerPage] = useState(10);

  // Analytics Data States
  const [salesData, setSalesData] = useState([]);
  const [orderStatusData, setOrderStatusData] = useState([]);
  const [categoryWiseSales, setCategoryWiseSales] = useState([]);
  const [monthlyTrends, setMonthlyTrends] = useState([]);
  const [kpiData, setKpiData] = useState([]);
  const [dailySalesTrend, setDailySalesTrend] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [analytics, setAnalytics] = useState({});

  // Loading and Error States
  const [isLoadingAnalytics, setIsLoadingAnalytics] = useState(false);
  const [analyticsError, setAnalyticsError] = useState(null);

  const [page1, setPage1] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [year, setYear] = useState(new Date().getFullYear());

  const handleChangeYear = (event) => {
    setYear(event.target.value);
    loadAnalyticsData(event.target.value);
  };

  const open = Boolean(anchorEl);

  const ITEM_HEIGHT = 48;

  const context = useContext(MyContext);

  // Enhanced fallback data with proper structure
  const getEnhancedFallbackData = () => {
    const fallbackMonthlySales = [
      { month: "JAN", sale: 45000, target: 54000, growth: 12 },
      { month: "FEB", sale: 38000, target: 45600, growth: -8 },
      { month: "MAR", sale: 52000, target: 62400, growth: 25 },
      { month: "APRIL", sale: 41000, target: 49200, growth: -15 },
      { month: "MAY", sale: 48000, target: 57600, growth: 18 },
      { month: "JUNE", sale: 55000, target: 66000, growth: 22 },
      { month: "JULY", sale: 49000, target: 58800, growth: -8 },
      { month: "AUG", sale: 53000, target: 63600, growth: 12 },
      { month: "SEP", sale: 47000, target: 56400, growth: -5 },
      { month: "OCT", sale: 58000, target: 69600, growth: 28 },
      { month: "NOV", sale: 51000, target: 61200, growth: -9 },
      { month: "DEC", sale: 62000, target: 74400, growth: 24 },
    ];

    const fallbackOrderStatus = [
      { name: 'Delivered', value: 156, color: powerBIColors.primary[3], amount: 890000 },
      { name: 'Processing', value: 43, color: powerBIColors.primary[2], amount: 245000 },
      { name: 'Shipped', value: 28, color: powerBIColors.primary[1], amount: 158000 },
      { name: 'Pending', value: 35, color: powerBIColors.primary[4], amount: 198000 },
      { name: 'Cancelled', value: 18, color: powerBIColors.primary[6], amount: 102000 },
    ];

    const fallbackCategoryWise = [
      { category: 'Electronics', sales: 285000, orders: 156, avgOrder: 1827 },
      { category: 'Fashion', sales: 198000, orders: 124, avgOrder: 1597 },
      { category: 'Home & Garden', sales: 167000, orders: 89, avgOrder: 1876 },
      { category: 'Sports', sales: 143000, orders: 76, avgOrder: 1882 },
      { category: 'Books', sales: 89000, orders: 67, avgOrder: 1328 },
      { category: 'Health', sales: 124000, orders: 54, avgOrder: 2296 },
    ];

    const fallbackKPI = [
      { name: 'Revenue', value: 85, max: 100, color: powerBIColors.primary[0], actualValue: 1206000, target: 1400000 },
      { name: 'Orders', value: 92, max: 100, color: powerBIColors.primary[1], actualValue: 566, target: 600 },
      { name: 'Success Rate', value: 88, max: 100, color: powerBIColors.primary[2], actualValue: '88%', target: '90%' },
      { name: 'Avg Order', value: 76, max: 100, color: powerBIColors.primary[3], actualValue: 2130, target: 2800 },
    ];

    const fallbackTopProducts = [
      {
        product: 'Wireless Bluetooth Headphones',
        sales: 156000,
        quantity: 245,
        orders: 89,
        image: '/api/placeholder/60/60',
        category: 'Electronics',
        growth: 15.2
      },
      {
        product: 'Smart Fitness Watch',
        sales: 134000,
        quantity: 198,
        orders: 76,
        image: '/api/placeholder/60/60',
        category: 'Electronics',
        growth: 12.8
      },
      {
        product: 'Premium Running Shoes',
        sales: 98000,
        quantity: 167,
        orders: 54,
        image: '/api/placeholder/60/60',
        category: 'Sports',
        growth: -5.4
      },
      {
        product: 'Organic Face Cream',
        sales: 87000,
        quantity: 234,
        orders: 67,
        image: '/api/placeholder/60/60',
        category: 'Health',
        growth: 28.7
      },
      {
        product: 'Coffee Table Set',
        sales: 76000,
        quantity: 98,
        orders: 43,
        image: '/api/placeholder/60/60',
        category: 'Home & Garden',
        growth: 8.9
      }
    ];

    return {
      salesData: fallbackMonthlySales,
      orderStatusData: fallbackOrderStatus,
      categoryWiseSales: fallbackCategoryWise,
      kpiData: fallbackKPI,
      topProducts: fallbackTopProducts,
      analytics: {
        totalOrders: 280,
        deliveredOrders: 156,
        cancelledOrders: 18,
        avgOrderValue: 2130,
        cancellationRate: 6.4,
        deliveryRate: 88.2
      }
    };
  };

  // Load analytics data from API
  const loadAnalyticsData = async (selectedYear = year) => {
    setIsLoadingAnalytics(true);
    setAnalyticsError(null);

    try {
      const response = await fetchDataFromApi(`/api/orders/sales?year=${selectedYear}`);

      if (response && response.success) {
        // Process and validate data
        const processedSalesData = (response.monthlySales || []).map(item => ({
          ...item,
          sale: item.sale || 0,
          target: item.target || item.sale * 1.2,
          growth: item.growth || 0
        }));

        const processedOrderStatus = (response.orderStatusData || []).map((item, index) => ({
          ...item,
          name: item.name || 'Unknown',
          value: item.value || 0,
          color: item.color || powerBIColors.primary[index % powerBIColors.primary.length],
          amount: item.amount || 0
        }));

        const processedTopProducts = (response.topProducts || []).map((item, index) => ({
          product: item.product || `Product ${index + 1}`,
          sales: item.sales || 0,
          quantity: item.quantity || 0,
          orders: item.orders || 0,
          image: item.image || '/api/placeholder/60/60',
          category: item.category || 'General',
          growth: Math.random() * 30 - 10 // Random growth for demo
        }));

        setSalesData(processedSalesData);
        setMonthlyTrends(processedSalesData);
        setTotalSales(response.totalSales || 0);
        setOrderStatusData(processedOrderStatus);
        setCategoryWiseSales(response.categoryWiseSales || []);
        setKpiData(response.kpiData || []);
        setDailySalesTrend(response.dailySalesTrend || []);
        setTopProducts(processedTopProducts);
        setAnalytics(response.analytics || {});

      } else {
        throw new Error('Failed to fetch analytics data');
      }
    } catch (error) {
      console.error('Error loading analytics:', error);
      setAnalyticsError(error.message);
      // Set enhanced fallback data
      const fallbackData = getEnhancedFallbackData();
      setSalesData(fallbackData.salesData);
      setMonthlyTrends(fallbackData.salesData);
      setOrderStatusData(fallbackData.orderStatusData);
      setCategoryWiseSales(fallbackData.categoryWiseSales);
      setKpiData(fallbackData.kpiData);
      setTopProducts(fallbackData.topProducts);
      setAnalytics(fallbackData.analytics);
    } finally {
      setIsLoadingAnalytics(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage1(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage1(0);
  };

  useEffect(() => {
    context.setisHideSidebarAndHeader(false);
    window.scrollTo(0, 0);
    context.setProgress(40);

    // Load basic data
    const loadBasicData = async () => {
      try {
        // Load products
        const productsRes = await fetchDataFromApi(`/api/products`);
        setProductList(productsRes || { products: [] });

        // Load counts
        const usersRes = await fetchDataFromApi("/api/user/get/count");
        setTotalUsers(usersRes?.userCount || 0);

        const ordersRes = await fetchDataFromApi("/api/orders/get/count");
        setTotalOrders(ordersRes?.orderCount || 0);

        const productsCountRes = await fetchDataFromApi("/api/products/get/count");
        setTotalProducts(productsCountRes?.productsCount || 0);

        const reviewsRes = await fetchDataFromApi("/api/productReviews/get/count");
        setTotalProductsReviews(reviewsRes?.productsReviews || 0);

        context.setProgress(100);
      } catch (error) {
        console.error('Error loading basic data:', error);
        context.setProgress(100);
      }
    };

    loadBasicData();
    loadAnalyticsData();
  }, []);

  const deleteProduct = (id) => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo?.email === "rismicmartpvtltd@gmail.com") {
      context.setProgress(40);
      deleteData(`/api/products/${id}`).then((res) => {
        context.setProgress(100);
        context.setAlertBox({
          open: true,
          error: false,
          msg: "Product Deleted!",
        });
        fetchDataFromApi(`/api/products`).then((res) => {
          setProductList(res || { products: [] });
        });
      });
    } else {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Only Admin can delete Product",
      });
    }
  };

  const handleChangeCategory = (event) => {
    if (event.target.value !== "all") {
      setcategoryVal(event.target.value);
      fetchDataFromApi(`/api/products/catId?catId=${event.target.value}`).then(
        (res) => {
          setProductList(res || { products: [] });
          context.setProgress(100);
        }
      );
    }
    if (event.target.value === "all") {
      setcategoryVal("all");
      setcategoryVal(event.target.value);
      fetchDataFromApi(`/api/products`).then((res) => {
        setProductList(res || { products: [] });
        context.setProgress(100);
      });
    }
  };

  const searchProducts = (keyword) => {
    if (keyword !== "") {
      fetchDataFromApi(`/api/search?q=${keyword}&page=1&perPage=${10000}`).then(
        (res) => {
          setProductList(res || { products: [] });
        }
      );
    } else {
      fetchDataFromApi(`/api/products`).then((res) => {
        setProductList(res || { products: [] });
      });
    }
  };

  const showPerPage = (e) => {
    setshowBy(e.target.value);
    fetchDataFromApi(`/api/products?page=${1}&perPage=${e.target.value}`).then(
      (res) => {
        setProductList(res || { products: [] });
        context.setProgress(100);
      }
    );
  };

  // Enhanced Custom Tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Paper
          elevation={8}
          sx={{
            p: 2,
            backgroundColor: context?.theme === "dark" ? "#2a2a2a" : "#ffffff",
            border: `2px solid ${powerBIColors.primary[0]}`,
            borderRadius: 2,
            minWidth: 200
          }}
        >
          <Typography variant="subtitle2" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
            {label}
          </Typography>
          <Divider sx={{ my: 1 }} />
          {payload.map((entry, index) => (
            <Box key={index} display="flex" alignItems="center" mb={0.5}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  backgroundColor: entry.color,
                  borderRadius: '50%',
                  mr: 1
                }}
              />
              <Typography variant="body2" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                {entry.dataKey}: {typeof entry.value === 'number' ? formatNumber(entry.value) : entry.value}
              </Typography>
            </Box>
          ))}
        </Paper>
      );
    }
    return null;
  };

  const formatCurrency = (value) => {
    if (!value || isNaN(value)) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatNumber = (value) => {
    if (!value || isNaN(value)) return '0';
    return new Intl.NumberFormat('en-IN').format(value);
  };

  const getGrowthColor = (growth) => {
    if (growth > 0) return powerBIColors.success[0];
    if (growth < 0) return powerBIColors.error[0];
    return powerBIColors.primary[7];
  };

  const getGrowthIcon = (growth) => {
    if (growth > 0) return <MdTrendingUp />;
    if (growth < 0) return <MdTrendingDown />;
    return <MdTrendingUp />;
  };


  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [productIdToDelete, setProductIdToDelete] = useState(null);

  const handleDeleteClick = (id) => {
    setProductIdToDelete(id);
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    deleteProduct(productIdToDelete);
    setOpenDeleteDialog(false);
  };





  return (
    <>
      <div className="right-content w-100">

        <div className="row dashboardBoxWrapperRow dashboard_Box dashboardBoxWrapperRowV2">
          <div className="col-md-12">
            <div className="dashboardBoxWrapper d-flex">
              <DashboardBox
                color={[powerBIColors.success[0], powerBIColors.success[1]]}
                icon={<FaUserCircle />}
                grow={true}
                title="Total Users"
                count={totalUsers}
              />
              <DashboardBox
                color={[powerBIColors.primary[2], powerBIColors.secondary[2]]}
                icon={<IoMdCart />}
                title="Total Orders"
                count={totalOrders}
              />
              <DashboardBox
                color={[powerBIColors.primary[0], powerBIColors.secondary[0]]}
                icon={<MdShoppingBag />}
                title="Total Products"
                count={totalProducts}
              />
              <DashboardBox
                color={[powerBIColors.warning[0], powerBIColors.warning[1]]}
                icon={<GiStarsStack />}
                title="Total Reviews"
                count={totalProductsReviews}
              />
            </div>
          </div>
        </div>







        {/* Products Table */}
        <div className="card shadow border-0 p-3 mt-4" style={{ borderRadius: '12px' }}>
          <Box display="flex" alignItems="center" mb={3}>
            <MdShoppingBag size={24} color={powerBIColors.primary[0]} style={{ marginRight: 8 }} />
            <Typography variant="h5" fontWeight="bold">Best Selling Products</Typography>
          </Box>

          <div className="row cardFilters mt-2 mb-3">
            <div className="col-md-3">
              <Typography variant="h6" mb={1} fontWeight="bold">CATEGORY BY</Typography>
              <FormControl size="small" className="w-100">
                <Select
                  value={categoryVal}
                  onChange={handleChangeCategory}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  className="w-100"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: powerBIColors.primary[0]
                    }
                  }}
                >
                  <MenuItem value="all">
                    <em>All Categories</em>
                  </MenuItem>
                  {context.catData?.categoryList?.length > 0 &&
                    context.catData.categoryList.map((cat, index) => (
                      <MenuItem
                        className="text-capitalize"
                        value={cat._id}
                        key={index}
                      >
                        {cat.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-9 d-flex justify-content-end">
              <div className="searchWrap d-flex">
                <SearchBox searchProducts={searchProducts} />
              </div>
            </div>
          </div>

          <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 2 }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          minWidth: column.minWidth,
                          backgroundColor: powerBIColors.primary[0],
                          color: 'white',
                          fontWeight: 'bold'
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {productList?.products?.length > 0 ? (
                    productList.products
                      .slice(page1 * rowsPerPage, page1 * rowsPerPage + rowsPerPage)
                      .reverse()
                      .map((item, index) => {
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              '&:hover': {
                                backgroundColor: `${powerBIColors.primary[0]}10`
                              }
                            }}
                          >
                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <div className="d-flex align-items-center productBox">
                                <div className="imgWrapper">
                                  <div className="img card shadow m-0">
                                    <LazyLoadImage
                                      alt={item?.name || "Product"}
                                      effect="blur"
                                      className="w-100"
                                      src={item?.images?.[0] || '/api/placeholder/60/60'}
                                      onError={(e) => {
                                        e.target.src = '/api/placeholder/60/60';
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="info pl-3">
                                  <Link to={`/product/details/${item.id}`}>
                                    <Typography variant="subtitle2" fontWeight="bold">
                                      {item?.name || 'Unnamed Product'}
                                    </Typography>
                                  </Link>
                                  <Typography variant="caption" color="text.secondary">
                                    {item?.description?.substring(0, 50) || 'No description available'}...
                                  </Typography>
                                </div>
                              </div>
                            </TableCell>

                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <Chip
                                label={item?.catName || 'Uncategorized'}
                                size="small"
                                sx={{
                                  backgroundColor: `${powerBIColors.primary[1]}20`,
                                  color: powerBIColors.primary[1],
                                  fontWeight: 'bold'
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <Chip
                                label={item?.subCatName || 'None'}
                                size="small"
                                variant="outlined"
                                sx={{
                                  borderColor: powerBIColors.primary[2],
                                  color: powerBIColors.primary[2]
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <Chip
                                label={item?.brand || 'No Brand'}
                                size="small"
                                sx={{
                                  backgroundColor: `${powerBIColors.primary[3]}20`,
                                  color: powerBIColors.primary[3],
                                  fontWeight: 'bold'
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{ textDecoration: 'line-through', color: 'text.secondary' }}
                                >
                                  ₹{item?.oldPrice || 0}
                                </Typography>
                                <Typography
                                  variant="subtitle2"
                                  fontWeight="bold"
                                  color={powerBIColors.primary[0]}
                                >
                                  ₹{item?.price || 0}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <Rating
                                name="read-only"
                                value={item?.rating || 0}
                                precision={0.5}
                                size="small"
                                readOnly
                                sx={{
                                  '& .MuiRating-iconFilled': {
                                    color: powerBIColors.warning[0]
                                  }
                                }}
                              />
                            </TableCell>

                            <TableCell style={{ minWidth: columns.minWidth }}>
                              <div className="actions d-flex align-items-center">
                                <Link to={`/product/details/${item.id}`}>
                                  <IconButton
                                    size="small"
                                    sx={{
                                      color: powerBIColors.primary[1],
                                      '&:hover': { backgroundColor: `${powerBIColors.primary[1]}20` }
                                    }}
                                  >
                                    <FaEye />
                                  </IconButton>
                                </Link>

                                <Link to={`/product/edit/${item.id}`}>
                                  <IconButton
                                    size="small"
                                    sx={{
                                      color: powerBIColors.success[0],
                                      '&:hover': { backgroundColor: `${powerBIColors.success[0]}20` }
                                    }}
                                  >
                                    <FaPencilAlt />
                                  </IconButton>
                                </Link>

                                <IconButton
                                  size="small"
                                  onClick={() => handleDeleteClick(item?.id)}
                                  sx={{
                                    color: powerBIColors.error[0],
                                    '&:hover': { backgroundColor: `${powerBIColors.error[0]}20` }
                                  }}
                                >
                                  <MdDelete />
                                </IconButton>
                              </div>
                              <Dialog
                                open={openDeleteDialog}
                                onClose={() => setOpenDeleteDialog(false)}
                              >
                                <DialogTitle>Confirm Delete</DialogTitle>
                                <DialogContent>
                                  <DialogContentText>
                                    Are you sure to delete this product?
                                  </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                  <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
                                    No
                                  </Button>
                                  <Button onClick={handleConfirmDelete} color="error" autoFocus>
                                    Yes
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </TableCell>

                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                        <Box textAlign="center">
                          <MdShoppingBag size={40} color={powerBIColors.primary[0]} />
                          <Typography variant="h6" color="text.secondary" mt={2}>
                            No products found
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Try adjusting your search or category filter
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={productList?.products?.length || 0}
              rowsPerPage={rowsPerPage}
              page={page1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiTablePagination-select': {
                  paddingRight: '35px !important',
                },
                '& .MuiSelect-icon': {
                  position: 'absolute',
                  right: '12px',
                  pointerEvents: 'none',
                },
                '& .MuiInputBase-root': {
                  position: 'relative',
                },
                '& .MuiTablePagination-toolbar': {
                  color: powerBIColors.primary[0]
                }
              }}
            />
          </Paper>
        </div>

        {/* Error Alert */}
        {analyticsError && (
          <Alert
            severity="warning"
            sx={{
              mt: 2,
              mb: 2,
              borderRadius: 2,
              '& .MuiAlert-action': {
                paddingTop: 0
              }
            }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => loadAnalyticsData()}
                sx={{ fontWeight: 'bold' }}
              >
                Retry
              </Button>
            }
          >
            <Typography variant="body2" fontWeight="bold">
              Analytics data could not be loaded. Showing demo data.
            </Typography>
          </Alert>
        )}

        {/* Loading Spinner */}
        {isLoadingAnalytics && (
          <Box display="flex" justifyContent="center" alignItems="center" my={4}>
            <CircularProgress size={40} thickness={4} sx={{ color: powerBIColors.primary[0] }} />
            <Typography variant="body1" sx={{ ml: 2, color: powerBIColors.primary[0] }}>
              Loading analytics...
            </Typography>
          </Box>
        )}

        {/* Power BI Style Analytics Dashboard */}
        <div className="row mt-4">
          {/* Main Sales Chart */}
          <div className="col-lg-8 col-md-12">
            <Card
              className="shadow border-0"
              sx={{
                height: '450px',
                background: context?.theme === "dark" ? "#1e1e1e" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[0]}20`,
                borderRadius: 3
              }}
            >
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Box display="flex" alignItems="center">
                    <FaChartLine size={20} color={powerBIColors.primary[0]} style={{ marginRight: 8 }} />
                    <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                      Sales Performance & Trends
                    </Typography>
                  </Box>
                  <FormControl size="small" style={{ minWidth: 100 }}>
                    <Select
                      value={year}
                      onChange={handleChangeYear}
                      displayEmpty
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: powerBIColors.primary[0]
                        }
                      }}
                    >
                      <MenuItem value={2020}>2020</MenuItem>
                      <MenuItem value={2021}>2021</MenuItem>
                      <MenuItem value={2022}>2022</MenuItem>
                      <MenuItem value={2023}>2023</MenuItem>
                      <MenuItem value={2024}>2024</MenuItem>
                      <MenuItem value={2025}>2025</MenuItem>
                      <MenuItem value={2026}>2026</MenuItem>
                      <MenuItem value={2027}>2027</MenuItem>
                      <MenuItem value={2028}>2028</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {salesData?.length > 0 && (
                  <ResponsiveContainer width="100%" height={350}>
                    <AreaChart data={salesData}>
                      <defs>
                        <linearGradient id="salesGradient" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor={powerBIColors.primary[0]} stopOpacity={0.8} />
                          <stop offset="95%" stopColor={powerBIColors.primary[0]} stopOpacity={0.1} />
                        </linearGradient>
                        <linearGradient id="targetGradient" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="5%" stopColor={powerBIColors.primary[1]} stopOpacity={0.8} />
                          <stop offset="95%" stopColor={powerBIColors.primary[1]} stopOpacity={0.1} />
                        </linearGradient>
                      </defs>
                      <XAxis
                        dataKey="month"
                        tick={{ fontSize: 11, fill: context?.theme === "dark" ? "#ffffff" : "#666666" }}
                        axisLine={{ stroke: context?.theme === "dark" ? "#444444" : "#e0e0e0" }}
                      />
                      <YAxis
                        tick={{ fontSize: 11, fill: context?.theme === "dark" ? "#ffffff" : "#666666" }}
                        axisLine={{ stroke: context?.theme === "dark" ? "#444444" : "#e0e0e0" }}
                        tickFormatter={formatNumber}
                      />
                      <CartesianGrid strokeDasharray="3 3" stroke={context?.theme === "dark" ? "#444444" : "#f0f0f0"} />
                      <Tooltip content={<CustomTooltip />} />
                      <Legend />
                      <Area
                        type="monotone"
                        dataKey="sale"
                        stroke={powerBIColors.primary[0]}
                        fill="url(#salesGradient)"
                        strokeWidth={3}
                        name="Actual Sales"
                      />
                      <Area
                        type="monotone"
                        dataKey="target"
                        stroke={powerBIColors.primary[1]}
                        fill="url(#targetGradient)"
                        strokeWidth={2}
                        strokeDasharray="5 5"
                        name="Target"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                )}
              </CardContent>
            </Card>
          </div>

          {/* Order Status Pie Chart */}
          <div className="col-lg-4 col-md-12">
            <Card
              className="shadow border-0"
              sx={{
                height: '450px',
                background: context?.theme === "dark" ? "#1e1e1e" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[1]}20`,
                borderRadius: 3
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <IoMdCart size={20} color={powerBIColors.primary[1]} style={{ marginRight: 8 }} />
                  <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                    Order Status Distribution
                  </Typography>
                </Box>
                {orderStatusData?.length > 0 && (
                  <ResponsiveContainer width="100%" height={350}>
                    <PieChart>
                      <Pie
                        data={orderStatusData}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={120}
                        paddingAngle={2}
                        dataKey="value"
                      >
                        {orderStatusData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                        <LabelList
                          dataKey="name"
                          position="outside"
                          style={{
                            fontSize: '12px',
                            fill: context?.theme === "dark" ? "#ffffff" : "#333333",
                            fontWeight: 'bold'
                          }}
                        />
                      </Pie>
                      <Tooltip content={<CustomTooltip />} />
                      <Legend
                        verticalAlign="bottom"
                        height={36}
                        wrapperStyle={{
                          color: context?.theme === "dark" ? "#ffffff" : "#333333",
                          fontSize: '12px',
                          fontWeight: 'bold'
                        }}
                        iconType="circle"
                      />
                    </PieChart>
                  </ResponsiveContainer>
                )}
              </CardContent>

            </Card>
          </div>
        </div>

        {/* Second Row - Category Performance & KPIs */}
        <div className="row mt-4">
          {/* Category Wise Sales */}
          <div className="col-lg-8 col-md-12">
            <Card
              className="shadow border-0"
              sx={{
                height: '400px',
                background: context?.theme === "dark" ? "#000000ff" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[2]}20`,
                borderRadius: 3
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <MdShoppingBag size={20} color={powerBIColors.primary[2]} style={{ marginRight: 8 }} />
                  <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                    Category Performance Analysis
                  </Typography>
                </Box>
                {categoryWiseSales?.length > 0 && (
                  <ResponsiveContainer width="100%" height={320}>
                    <BarChart data={categoryWiseSales} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke={context?.theme === "dark" ? "#444444" : "#f0f0f0"} />
                      <XAxis
                        dataKey="category"
                        tick={{ fontSize: 10, fill: context?.theme === "dark" ? "#ffffff" : "#666666" }}
                        angle={-45}
                        textAnchor="end"
                        height={80}
                        axisLine={{ stroke: context?.theme === "dark" ? "#444444" : "#e0e0e0" }}
                      />
                      <YAxis
                        tick={{ fontSize: 11, fill: context?.theme === "dark" ? "#ffffff" : "#666666" }}
                        axisLine={{ stroke: context?.theme === "dark" ? "#444444" : "#e0e0e0" }}
                        tickFormatter={formatNumber}
                      />
                      <Tooltip content={<CustomTooltip />} />
                      <Legend />
                      <Bar dataKey="sales" fill={powerBIColors.primary[0]} name="Sales (₹)" radius={[4, 4, 0, 0]} />
                      <Bar dataKey="orders" fill={powerBIColors.primary[1]} name="Orders Count" radius={[4, 4, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </CardContent>
            </Card>
          </div>

          {/* KPI Radial Chart */}
          <div className="col-lg-4 col-md-12">
            <Card
              className="shadow border-0"
              sx={{
                height: '400px',
                background: context?.theme === "dark" ? "#1e1e1e" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[3]}20`,
                borderRadius: 3
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <GiStarsStack size={20} color={powerBIColors.primary[3]} style={{ marginRight: 8 }} />
                  <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                    Key Performance Indicators
                  </Typography>
                </Box>
                {kpiData?.length > 0 && (
                  <ResponsiveContainer width="100%" height={320}>
                    <RadialBarChart cx="50%" cy="50%" innerRadius="20%" outerRadius="90%" data={kpiData}>
                      <RadialBar
                        minAngle={15}
                        label={{ position: 'insideStart', fill: '#fff', fontSize: 12, fontWeight: 'bold' }}
                        background
                        clockWise
                        dataKey="value"
                      >
                        {kpiData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </RadialBar>
                      <Legend
                        iconSize={10}
                        wrapperStyle={{
                          fontSize: '12px',
                          color: context?.theme === "dark" ? "#ffffff" : "#000000",
                          fontWeight: 'bold'
                        }}
                      />
                      <Tooltip content={<CustomTooltip />} />
                    </RadialBarChart>
                  </ResponsiveContainer>
                )}
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Third Row - Growth Trends */}
        <div className="row mt-4">
          <div className="col-12">
            <Card
              className="shadow border-0"
              sx={{
                background: context?.theme === "dark" ? "#1e1e1e" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[4]}20`,
                borderRadius: 3
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <FaChartLine size={20} color={powerBIColors.primary[4]} style={{ marginRight: 8 }} />
                  <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                    Monthly Growth Trends & Comparison
                  </Typography>
                </Box>
                {monthlyTrends?.length > 0 && (
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={monthlyTrends}>
                      <CartesianGrid strokeDasharray="3 3" stroke={context?.theme === "dark" ? "#444444" : "#f0f0f0"} />
                      <XAxis
                        dataKey="month"
                        tick={{ fontSize: 11, fill: context?.theme === "dark" ? "#ffffff" : "#666666" }}
                        axisLine={{ stroke: context?.theme === "dark" ? "#444444" : "#e0e0e0" }}
                      />
                      <YAxis
                        tick={{ fontSize: 11, fill: context?.theme === "dark" ? "#ffffff" : "#666666" }}
                        axisLine={{ stroke: context?.theme === "dark" ? "#444444" : "#e0e0e0" }}
                        tickFormatter={formatNumber}
                      />
                      <Tooltip content={<CustomTooltip />} />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="sale"
                        stroke={powerBIColors.primary[0]}
                        strokeWidth={3}
                        dot={{ fill: powerBIColors.primary[0], strokeWidth: 2, r: 6 }}
                        name="Sales"
                      />
                      <Line
                        type="monotone"
                        dataKey="target"
                        stroke={powerBIColors.warning[1]}
                        strokeWidth={2}
                        strokeDasharray="8 8"
                        dot={{ fill: powerBIColors.warning[1], strokeWidth: 2, r: 4 }}
                        name="Target"
                      />
                      <Line
                        type="monotone"
                        dataKey="growth"
                        stroke={powerBIColors.success[0]}
                        strokeWidth={2}
                        dot={{ fill: powerBIColors.success[0], strokeWidth: 2, r: 4 }}
                        name="Growth %"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                )}
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Fourth Row - Top Products & Analytics Summary */}
        <div className="row mt-4">
          {/* Enhanced Top Products */}
          <div className="col-lg-6 col-md-12">
            <Card
              className="shadow border-0"
              sx={{
                background: context?.theme === "dark" ? "#1e1e1e" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[5]}20`,
                borderRadius: 3,
                minHeight: '400px'
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <FaTrophy size={20} color={powerBIColors.primary[5]} style={{ marginRight: 8 }} />
                  <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                    Top Selling Products
                  </Typography>
                </Box>
                <Box sx={{ maxHeight: 320, overflow: 'auto' }}>
                  {topProducts && topProducts.length > 0 ? (
                    topProducts.slice(0, 5).map((product, index) => (
                      <Paper
                        key={index}
                        elevation={2}
                        sx={{
                          p: 2,
                          mb: 2,
                          backgroundColor: context?.theme === "dark" ? "#2a2a2a" : "#f8f9fa",
                          borderRadius: 2,
                          border: `1px solid ${powerBIColors.primary[index % powerBIColors.primary.length]}20`,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: 4
                          }
                        }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Box display="flex" alignItems="center" flex={1}>
                            <Avatar
                              src={product.image || '/api/placeholder/60/60'}
                              alt={product.product}
                              sx={{
                                width: 60,
                                height: 60,
                                mr: 2,
                                border: `2px solid ${powerBIColors.primary[index % powerBIColors.primary.length]}`,
                                backgroundColor: '#f5f5f5'
                              }}
                            >
                              <FaBoxOpen color={powerBIColors.primary[index % powerBIColors.primary.length]} />
                            </Avatar>
                            <Box flex={1}>
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                color={context?.theme === "dark" ? "#ffffff" : "#000000"}
                                sx={{ mb: 0.5 }}
                              >
                                {product.product || 'Unknown Product'}
                              </Typography>
                              <Box display="flex" alignItems="center" gap={1} mb={1}>
                                <Chip
                                  label={product.category || 'General'}
                                  size="small"
                                  sx={{
                                    backgroundColor: `${powerBIColors.primary[index % powerBIColors.primary.length]}20`,
                                    color: powerBIColors.primary[index % powerBIColors.primary.length],
                                    fontWeight: 'bold'
                                  }}
                                />
                                <Chip
                                  icon={getGrowthIcon(product.growth)}
                                  label={`${product.growth > 0 ? '+' : ''}${product.growth?.toFixed(1) || 0}%`}
                                  size="small"
                                  sx={{
                                    backgroundColor: `${getGrowthColor(product.growth)}20`,
                                    color: getGrowthColor(product.growth),
                                    fontWeight: 'bold'
                                  }}
                                />
                              </Box>
                              <Box display="flex" gap={2}>
                                <Typography variant="caption" color="text.secondary">
                                  <strong>Qty:</strong> {formatNumber(product.quantity || 0)}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  <strong>Orders:</strong> {formatNumber(product.orders || 0)}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                          <Box textAlign="right">
                            <Typography
                              variant="h6"
                              fontWeight="bold"
                              color={powerBIColors.primary[0]}
                              sx={{ mb: 0.5 }}
                            >
                              {formatCurrency(product.sales || 0)}
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={Math.min((product.sales / (topProducts[0]?.sales || 1)) * 100, 100)}
                              sx={{
                                width: 80,
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: `${powerBIColors.primary[index % powerBIColors.primary.length]}20`,
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: powerBIColors.primary[index % powerBIColors.primary.length],
                                  borderRadius: 3
                                }
                              }}
                            />
                          </Box>
                        </Box>
                      </Paper>
                    ))
                  ) : (
                    <Box textAlign="center" py={4}>
                      <FaBoxOpen size={40} color={powerBIColors.primary[5]} />
                      <Typography variant="body1" color="text.secondary" mt={2}>
                        No top products data available
                      </Typography>
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </div>

          {/* Enhanced Analytics Summary */}
          <div className="col-lg-6 col-md-12">
            <Card
              className="shadow border-0"
              sx={{
                background: context?.theme === "dark" ? "#1e1e1e" : "#ffffff",
                border: `1px solid ${powerBIColors.primary[6]}20`,
                borderRadius: 3,
                minHeight: '400px'
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={3}>
                  <FaChartLine size={20} color={powerBIColors.primary[6]} style={{ marginRight: 8 }} />
                  <Typography variant="h6" fontWeight="bold" color={context?.theme === "dark" ? "#ffffff" : "#000000"}>
                    Business Analytics Summary
                  </Typography>
                </Box>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        background: `linear-gradient(135deg, ${powerBIColors.primary[0]}20, ${powerBIColors.primary[0]}10)`,
                        border: `1px solid ${powerBIColors.primary[0]}30`,
                        borderRadius: 3,
                        transition: 'transform 0.3s ease',
                        '&:hover': { transform: 'scale(1.05)' }
                      }}
                    >
                      <IoMdCart size={24} color={powerBIColors.primary[0]} />
                      <Typography variant="h4" fontWeight="bold" color={powerBIColors.primary[0]} mt={1}>
                        {formatNumber(analytics.totalOrders || 0)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" fontWeight="bold">
                        Total Orders
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        background: `linear-gradient(135deg, ${powerBIColors.success[0]}20, ${powerBIColors.success[0]}10)`,
                        border: `1px solid ${powerBIColors.success[0]}30`,
                        borderRadius: 3,
                        transition: 'transform 0.3s ease',
                        '&:hover': { transform: 'scale(1.05)' }
                      }}
                    >
                      <MdTrendingUp size={24} color={powerBIColors.success[0]} />
                      <Typography variant="h4" fontWeight="bold" color={powerBIColors.success[0]} mt={1}>
                        {analytics.deliveryRate || 0}%
                      </Typography>
                      <Typography variant="caption" color="text.secondary" fontWeight="bold">
                        Delivery Rate
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        background: `linear-gradient(135deg, ${powerBIColors.warning[0]}20, ${powerBIColors.warning[0]}10)`,
                        border: `1px solid ${powerBIColors.warning[0]}30`,
                        borderRadius: 3,
                        transition: 'transform 0.3s ease',
                        '&:hover': { transform: 'scale(1.05)' }
                      }}
                    >
                      <FaUserCircle size={24} color={powerBIColors.warning[0]} />
                      <Typography variant="h4" fontWeight="bold" color={powerBIColors.warning[0]} mt={1}>
                        {formatCurrency(analytics.avgOrderValue || 0)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" fontWeight="bold">
                        Avg Order Value
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={6}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        background: `linear-gradient(135deg, ${powerBIColors.error[0]}20, ${powerBIColors.error[0]}10)`,
                        border: `1px solid ${powerBIColors.error[0]}30`,
                        borderRadius: 3,
                        transition: 'transform 0.3s ease',
                        '&:hover': { transform: 'scale(1.05)' }
                      }}
                    >
                      <MdTrendingDown size={24} color={powerBIColors.error[0]} />
                      <Typography variant="h4" fontWeight="bold" color={powerBIColors.error[0]} mt={1}>
                        {analytics.cancellationRate || 0}%
                      </Typography>
                      <Typography variant="caption" color="text.secondary" fontWeight="bold">
                        Cancellation Rate
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>

                {/* Additional Analytics */}
                <Box mt={3}>
                  <Divider sx={{ mb: 2 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Box textAlign="center">
                        <Typography variant="body2" color="text.secondary">
                          Delivered Orders
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" color={powerBIColors.success[0]}>
                          {formatNumber(analytics.deliveredOrders || 0)}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box textAlign="center">
                        <Typography variant="body2" color="text.secondary">
                          Cancelled Orders
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" color={powerBIColors.error[0]}>
                          {formatNumber(analytics.cancelledOrders || 0)}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </div>
        </div>


      </div>
    </>
  );
};

export default Dashboard;

